const MemberTypePropertiesListItem = ({ member_type_property }) => {
  const requiredString = member_type_property.required ? (
    <small>(required)</small>
  ) : null;

  return (
    <li
      className="member_type_property"
      data-member-type-property-id={member_type_property.id}
    >
      <h3>
        {member_type_property.name} {requiredString}
      </h3>
      {member_type_property.type}
    </li>
  );
};

export default MemberTypePropertiesListItem;
